import { render, staticRenderFns } from "./ModerationStructure.vue?vue&type=template&id=370c5916"
import script from "./ModerationStructure.vue?vue&type=script&lang=js"
export * from "./ModerationStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports